module.exports = __webpack_public_path__ + "static/board-24-d3860884ddd88fa2808ed3f34bd49ca0.jpg";